import { render, staticRenderFns } from "./Register-2.vue?vue&type=template&id=1e816e22&scoped=true&"
import script from "./Register-2.vue?vue&type=script&lang=js&"
export * from "./Register-2.vue?vue&type=script&lang=js&"
import style0 from "./Register-2.vue?vue&type=style&index=0&id=1e816e22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e816e22",
  null
  
)

export default component.exports